import { __assign, __rest } from "tslib";
// DS: DS3.1.1
import React from 'react';
import c from 'classnames';
import InputFieldOutline from '../InputFieldOutline';
import BaseInput from '../BaseInput';
import s from './InputField.scss';
/**
 * One of our standard `<input />`s.
 *
 * Provides space for a prefix and postfix, and allows indication of success or error via `validationResult`.
 */
var InputField = React.forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'text' : _b, prefix = _a.prefix, postfix = _a.postfix, validationResult = _a.validationResult, className = _a.className, disabled = _a.disabled, rest = __rest(_a, ["type", "prefix", "postfix", "validationResult", "className", "disabled"]);
    return (React.createElement(InputFieldOutline, { className: c(s['root'], className), outlineStyle: disabled ? 'disabled' : validationResult },
        prefix && React.createElement("span", { className: s['prefix'] }, prefix),
        React.createElement(BaseInput, __assign({ type: type, className: s['input'], disabled: disabled, ref: ref }, rest)),
        postfix && React.createElement("span", { className: s['postfix'] }, postfix)));
});
InputField.displayName = 'InputField';
export default InputField;
//# sourceMappingURL=InputField.js.map